// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const rut: CountryValidator<"CL"> = createValidator(
  "cl.rut",
  35,
);

export default rut;
export const compact = rut.compact;
export const format = rut.format;
export const validate = rut.validate;
export const generate = (): string =>
  rut.generate?.() ??
  (() => {
    throw new Error(
      "Validator cl.rut cannot generate values",
    );
  })();
